// Module
var code = "<div class=\"empty-row\" ng-class=\"{ 'no-padding': noPadding, 'no-frills': noFrills }\"> <div ng-class=\"{ 'no-border': noBorder }\" ng-if=\"!transcluded\">{{defaultMsg}}</div> <div ng-class=\"{ 'no-border': noBorder }\" ng-if=\"transcluded\" ng-transclude></div> </div> ";
// Exports
var _module_exports =code;;
var path = '/views/cs-empty-row.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;